import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import Logo from '../../assets/logos/CL-Logo-Transparent-260x60.png';
import paths from '../../constants/routes.json';
import { GetFeatureState } from '../../hooks/getFeatureState';

const Sidenav: React.FC = () => {
  const activitySectionEnabled = GetFeatureState('ActivitySection');
  const activitiesPathExist = useRouteMatch(paths.ACTIVITIES);

  return (
    <div className="hidden md:flex md:flex-shrink-0">
      <div className="flex flex-col w-36">
        {/* Sidebar */}
        <div className="flex flex-col flex-1">
          <div className="flex items-center h-16 flex-shrink-0 bg-white">
            <img className="m-1 h-8 w-auto" src={Logo} alt="CloudListings" />
            {/* <span className="ml-4 text-lg text-white">Sprout HQ</span> */}
          </div>
          <div className="flex-1 flex flex-col overflow-y-auto">
            <nav className="flex-1 px-2 py-4 bg-gray-800 space-y-3 flex flex-col items-center">
              <Link
                to={paths.OVERVIEW}
                className={`${
                  useRouteMatch(paths.OVERVIEW)
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-400 hover:bg-gray-700'
                }  flex flex-col justify-center items-center flex-shrink-0 h-20 w-24 rounded-lg`}
              >
                <svg
                  className="h-7 w-7"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                  />
                </svg>
                <p className="mt-2 text-sm">Overview</p>
              </Link>
              {/* TODO Feature flagging component to fix useHokk within JSX condition
              original code:
               <Link
                  to={paths.ACTIVITIES}
                  className={`${useRouteMatch(paths.ACTIVITIES)
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-400 hover:bg-gray-700'
                  }  flex flex-col justify-center items-center flex-shrink-0 h-20 w-24 rounded-lg`}
                >
              */}
              {activitySectionEnabled ? (
                <Link
                  to={paths.ACTIVITIES}
                  className={`${
                    activitiesPathExist
                      ? 'bg-gray-900 text-white'
                      : 'text-gray-400 hover:bg-gray-700'
                  }  flex flex-col justify-center items-center flex-shrink-0 h-20 w-24 rounded-lg`}
                >
                  {/* Heroicon name: outline/chart-bar */}
                  <svg
                    className="h-7 w-7"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                  <p className="mt-2 text-sm">Activities</p>
                </Link>
              ) : (
                <></>
              )}
              <Link
                to={paths.LISTINGS}
                className={`${
                  useRouteMatch(paths.LISTINGS)
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-400 hover:bg-gray-700'
                }  flex flex-col justify-center items-center flex-shrink-0 h-20 w-24 rounded-lg`}
              >
                {/* Heroicon name: outline/chart-bar */}
                <svg
                  className="h-7 w-7"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>
                <p className="mt-2 text-sm">Listings</p>
              </Link>

              <Link
                to={paths.PEOPLE}
                className={`${
                  useRouteMatch(paths.PEOPLE)
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-400 hover:bg-gray-700'
                }  flex flex-col justify-center items-center flex-shrink-0 h-20 w-24 rounded-lg`}
              >
                {/* Heroicon name: outline/chart-bar */}
                <svg
                  className="h-7 w-7"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
                <p className="mt-2 text-sm">Contacts</p>
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidenav;
